import { configureStore } from "@reduxjs/toolkit";

//reducer
import modalReducer from "./reducer/modal.reducer";
import commonReducer from "./reducer/common.reducer";
import homeReducer from "./reducer/home.reducer";
import productReducer from "./reducer/product.reducer";
import cartReducer from "./reducer/cart.reducer";
import orderReducer from "./reducer/order.reducer";

const reducer = {
  modal: modalReducer,
  common: commonReducer,
  home: homeReducer,
  product: productReducer,
  cart: cartReducer,
  order: orderReducer,
};

const store = configureStore({
  reducer: reducer,
  devTools: process.env.REACT_APP_DEV_TOOL,
});

export default store;
